import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const BillingCycleListDetails = () => { 
  const [billingCycles, setBillingCycles] = useState([]); 

  useEffect(() => { 
    

    fetchBillingCycles(); 
  }, []); 


    const fetchBillingCycles = async () => { 
      try { 
        const url = `${API_DOMAIN}${API_ROUTES.billing_cycle}`; 
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
        for (let i = 0; i < response.data.length; i++) {
          const customerData = await fetchCustomer(response.data[i].customer);
          response.data[i].customer_name = customerData.name;
        }
        setBillingCycles(response.data);
        
        
        // setBillingCycles(response.data); 
      } catch (error) { 
        console.error('Error fetching billing cycles:', error); 
      } 
    }; 
    
    const fetchCustomer = async (customerId) => {
  try {
    const url = `${API_DOMAIN}${API_ROUTES.customer}${customerId}/`;
    const token = localStorage.getItem('token');
    
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching customer:', error);
  }
};

  const columns = [ 
    { label: 'Customer', value: 'customer_name' }, 
    { label: 'Start Date', value: 'start_date' }, 
    { label: 'End Date', value: 'end_date' }, 
    { label: 'Billing Frequency', value: 'billing_frequency' }, 
    { label: 'Next Billing Date', value: 'next_billing_date' }, 
    { label: 'Status', value: 'status' }, 

  ]; 



  const handleEditDetails = (billingCycleId) => { 
    //console.log('Edit Details', billingCycleId); 
    const encodedId = btoa(billingCycleId);
    window.location.href = `/billing/cycle/input/${encodedId}`; 
  };

  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={billingCycles} actionButtons={actionButtons} />; 
}; 

export default BillingCycleListDetails;